import { RootState } from '@/store'

export const getCustomApp = (state: RootState) => {
  return state.customAppEditPage ? state.customAppEditPage.customApp : {}
}

export const getCustomConnector = (state: RootState) => {
  return state.customAppEditPage.customConnector || null
}

export const getCustomMicroapps = (state: RootState) => {
  return state.customAppEditPage.customMicroapps || null
}

export const getClientCredential = (state: RootState) => {
  return state.customAppEditPage.customApp.clientCredential || null
}
